// The Wind Turbine — turning standards into sovereign capability.
export default function WindTurbine() {
  const hub = { x: 285, y: 200 };

  // Three blades as tapered shapes radiating from the hub.
  const blade = (angleDeg) => {
    const a = (angleDeg * Math.PI) / 180;
    const len = 150;
    const tipX = hub.x + len * Math.cos(a);
    const tipY = hub.y + len * Math.sin(a);
    const w = 14;
    const pa = a + Math.PI / 2;
    const bx = hub.x + w * Math.cos(pa);
    const by = hub.y + w * Math.sin(pa);
    const cx2 = hub.x - w * Math.cos(pa);
    const cy2 = hub.y - w * Math.sin(pa);
    return `${bx},${by} ${tipX},${tipY} ${cx2},${cy2}`;
  };

  const Label = ({ x, y, anchor, title, lx1, ly1, lx2, ly2 }) => (
    <g>
      <line x1={lx1} y1={ly1} x2={lx2} y2={ly2} stroke="#2A3654" strokeWidth="1" />
      <text x={x} y={y} textAnchor={anchor} fontFamily="'IBM Plex Sans', sans-serif" fontSize="13" fill="#E8ECF6" fontWeight="500">
        {title}
      </text>
    </g>
  );

  return (
    <svg viewBox="0 0 600 600" className="w-full h-auto" role="img"
      aria-label="The Wind Turbine model: rotor blades represent values, policies and critical standards; the gearbox represents community, partners and DEI; the generator represents sovereign capability and trusted outcomes; the tail vane represents operations and management.">
      <defs>
        <linearGradient id="wtGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#46E0D0" />
          <stop offset="100%" stopColor="#8B7CFF" />
        </linearGradient>
      </defs>

      {/* tower */}
      <polygon points={`${hub.x - 7},${hub.y} ${hub.x + 7},${hub.y} ${hub.x + 16},540 ${hub.x - 16},540`} fill="#141B2E" stroke="#2A3654" strokeWidth="1.5" />

      {/* nacelle / gearbox */}
      <rect x={hub.x - 6} y={hub.y - 22} width="70" height="44" rx="10" fill="#1E2740" stroke="url(#wtGrad)" strokeWidth="1.5" />
      {/* tail vane */}
      <polygon points={`${hub.x + 64},${hub.y - 14} ${hub.x + 110},${hub.y - 30} ${hub.x + 110},${hub.y + 18} ${hub.x + 64},${hub.y + 10}`} fill="rgba(139,124,255,0.12)" stroke="#8B7CFF" strokeWidth="1.5" />

      {/* blades */}
      <polygon points={blade(270)} fill="url(#wtGrad)" opacity="0.9" />
      <polygon points={blade(30)} fill="url(#wtGrad)" opacity="0.9" />
      <polygon points={blade(150)} fill="url(#wtGrad)" opacity="0.9" />

      {/* hub */}
      <circle cx={hub.x} cy={hub.y} r="12" fill="url(#wtGrad)" />

      {/* labels */}
      <Label title="Rotor blades — values, policies & critical standards" x={150} y={48} anchor="start" lx1={hub.x} ly1={hub.y - 140} lx2={170} ly2={52} />
      <Label title="Gearbox — community, partners & DEI" x={360} y={150} anchor="start" lx1={hub.x + 30} ly1={hub.y - 18} lx2={355} ly2={146} />
      <Label title="Tail vane — operations & management" x={400} y={230} anchor="start" lx1={hub.x + 105} ly1={hub.y - 6} lx2={395} ly2={226} />
      <Label title="Generator — sovereign capability & trusted outcomes" x={330} y={470} anchor="start" lx1={hub.x + 8} ly1={420} lx2={325} ly2={466} />
    </svg>
  );
}
